import { render } from "./SncrBalanceBanner.vue?vue&type=template&id=72829c1b&scoped=true"
import script from "./SncrBalanceBanner.vue?vue&type=script&lang=js"
export * from "./SncrBalanceBanner.vue?vue&type=script&lang=js"

import "./SncrBalanceBanner.vue?vue&type=style&index=0&id=72829c1b&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72829c1b"]])

export default __exports__